module.exports = __webpack_public_path__ + "static/media/afn.77031d9d.jpeg";